import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActionCardConfigInterface, BrightsideUiModule } from '@brightside/brightside-ui';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { ServiceState } from '@brightside-web/desktop/data-access/service-inventory';
import { HardshipRequiredDocsService } from '../../hardship-required-docs.service';

@Component({
    selector: 'bw-hardship-actions-card',
    imports: [CommonModule, BrightsideUiModule],
    templateUrl: './hardship-actions-card.component.html',
    styleUrl: './hardship-actions-card.component.css'
})
export class HardshipActionsCardComponent {
  private _translateSvc = inject(TranslateService);
  private _router = inject(Router);
  private _hardshipService = inject(HardshipRequiredDocsService);

  data: { route: string; state: string };
  actionCardConfig: Record<string, ActionCardConfigInterface> = {
    [ServiceState.UPLOAD]: {
      label: 'TAKE_ACTION',
      labelSub: 'HARDSHIP_PROGRAM_ADDITIONAL_DOCS_MINUTES',
      title: 'HARDSHIP_PROGRAM_ADDITIONAL_DOCS_TITLE',
      body: 'HARDSHIP_PROGRAM_ADDITIONAL_DOCS_DESC',
      labelSubRemoveDash: true,
      cardStyle: 'small',
      labelIcon: 'icon-actions',
      marginBottom: 'small',
    },
    [ServiceState.READY]: {
      label: 'TAKE_ACTION',
      labelSub: 'HARDSHIP_PROGRAM_UPLOAD_MINUTES',
      title: 'HARDSHIP_PROGRAM_UPLOAD_TITLE',
      body: 'HARDSHIP_PROGRAM_UPLOAD_DESC',
      labelSubRemoveDash: true,
      cardStyle: 'small',
      labelIcon: 'icon-actions',
      marginBottom: 'small',
    },
    [ServiceState.REVIEW]: {
      label: 'IN_REVIEW',
      title: 'HARDSHIP_PROGRAM_REVIEW_TITLE',
      body: 'HARDSHIP_PROGRAM_REVIEW_DESC',
      labelSubRemoveDash: true,
      cardStyle: 'small',
      labelIcon: 'hour-glass',
      marginBottom: 'small',
    },
  };

  navigate(state: string) {
  
    switch (state) {
      case ServiceState.READY:
        this._hardshipService.setActiveView('hardship_confirm_request');
        this._router.navigate(['hardship','review']);
        break;
      case ServiceState.UPLOAD:
        this._router.navigate(['hardship','additional-documents']);
        break;
      case ServiceState.REVIEW:
        this._hardshipService.setActiveView('hardship_request_details');
        this._router.navigate(['hardship','review']);
        break;
    }
  }
}
